import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../components/AssignBranch.css";

const AssignBranch = () => {
  const { patient_id } = useParams(); // patient id from route
  const navigate = useNavigate();
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [loading, setLoading] = useState(false);

  // Fetch branches on mount
  useEffect(() => {
    fetch("https://newerp.awasthivitality.com/api/branches/available")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setBranches(data.data);
        }
      })
      .catch((err) => console.error("Error fetching branches:", err));
  }, []);

  // Handle assign
  const handleAssign = async () => {
    if (!selectedBranch) {
      alert("Please select a branch");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `https://newerp.awasthivitality.com/api/patient/assign-branch/${patient_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ branch_id: selectedBranch }),
        }
      );

      const result = await response.json();

      if (result.success) {
        alert("Branch assigned successfully ✅");
        navigate(-1); // go back after assigning
      } else {
        alert(result.msg || "Failed to assign branch ❌");
      }
    } catch (error) {
      console.error("Error assigning branch:", error);
      alert("Something went wrong, please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="assign-branch-container">
      <div className="assign-branch-card">
        <h2>Assign Branch</h2>
        <p>
          <strong>Patient ID:</strong> {patient_id}
        </p>

        <label>
          <strong>Select Branch</strong>
        </label>
        <select
          className="assign-branch-dropdown"
          value={selectedBranch}
          onChange={(e) => setSelectedBranch(e.target.value)}
        >
          <option value="">-- Select Branch --</option>
          {branches.map((branch) => (
            <option key={branch.branch_id} value={branch.branch_id}>
              {branch.branch_name}
            </option>
          ))}
        </select>

        <button
          className="assign-branch-btn"
          onClick={handleAssign}
          disabled={loading}
        >
          {loading ? "Assigning..." : "Assign"}
        </button>
      </div>
    </div>
  );
};

export default AssignBranch;
